import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const pickRoute = createRoute({
  path: 'pick',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/pick/page'), 'PickPage'),
  errorComponent: RouteError,
})
